import axios from "axios"
export function getAdvertiserData(token, page, pageSize) {
    return axios.get(process.env.REACT_APP_API_URL + `/getAdvertisers`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}